module.exports = __webpack_public_path__ + "img/fm-Path 4 Copy 4@3x.64b4e5d1.png";